import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Snackbar from '../components/snackbar';
import * as snackbarAction from '../actions/snackbarAction';
// { open: true, message: 'nothing', type: 'warning' };
function mapStateToProps(state) {
  return state.Snackbar;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...snackbarAction,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Snackbar);
